var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(" Cronometro: "+_vm._s(_vm.tiempo.tiempoFaltanteMinutos + "m ")+" "+_vm._s(_vm.tiempo.tiempoFaltanteSegundos + "s")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }